export const PROFILES = Object.freeze({
  TENANT_BUYER: 'TENANT_BUYER',
  OWNER: 'OWNER',
  INDICA_AI: 'INDICA_AI',
  ACCREDITED: 'ACCREDITED',
});
